var StageAlign = (function () {
    function StageAlign() {
    }
    return StageAlign;
}());
export { StageAlign };
StageAlign.BOTTOM = "B";
StageAlign.BOTTOM_LEFT = "BL";
StageAlign.BOTTOM_RIGHT = "BR";
StageAlign.LEFT = "L";
StageAlign.RIGHT = "R";
StageAlign.TOP = "T";
StageAlign.TOP_LEFT = "TL";
StageAlign.TOP_RIGHT = "TR";
